import { Setting } from "../App";
import axios from "axios";
import { CUSTOMER_API_URL } from "../constants";
import { AddSubscriptionLineResponseTypeDefine } from "../types/api/add-subscription-line-api-type";

export const useSubscriptionAddProducts = (setting: Setting) => {
  const addCartProducts = (
    products: { variantId: string; quantity: number; sellingPlanId: string }[],
    success: () => void,
    failed?: (message: string) => void
  ) => {
    (async () => {
      const requests = products.map((product) => {
        const planId = `gid://shopify/SellingPlan/${product.sellingPlanId}`;
        const variantId = `gid://shopify/ProductVariant/${product.variantId}`;
        const quantity = Number(product.quantity);

        return axios.post(
          `${CUSTOMER_API_URL}?action=addSubscriptionLineToFirstSubscription`,
          {
            planId,
            variantId,
            quantity,
          },
          { headers: { Authorization: setting.token } }
        );
      });

      Promise.all(requests).then((results) => {
        if (
          results.some(
            (result) =>
              result.data.status ===
                AddSubscriptionLineResponseTypeDefine.NONE_SUBSCRIPTION ||
              result.data.status ===
                AddSubscriptionLineResponseTypeDefine.API_ERROR
          )
        ) {
          if (failed) failed("api error");
        } else {
          success();
        }
      });
    })();
  };

  return {
    addCartProducts,
  };
};
